import React from 'react';

import PropTypes from 'prop-types';

import { DirectionsMap } from 'wanderu-component-directions';
import { Checkbox } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './Station.scss';

const propTypes = {
    direction: PropTypes.string.isRequired,
    setStationActive: PropTypes.func.isRequired,
    setStationOnlyActive: PropTypes.func.isRequired,
    station: PropTypes.object.isRequired,
};

function Station(props) {
    const {
        direction,
        t,
        setStationActive,
        setStationOnlyActive,
        station: {
            id,
            isActive,
            name,
        },
    } = props;

    function _onChange(isActive) {
        setStationActive(id, isActive, direction);
    }

    function _onlyStationClick() {
        setStationOnlyActive(id, direction);
    }
    return (
        <div className={styles.checkboxRow}>
            <Checkbox
                checked={isActive}
                className={styles.checkbox}
                id={`station-${id}`}
                onChange={_onChange}
                delayChange
            />
            <label
                className={styles.label}
                htmlFor="stations"
                onClick={() => _onChange(!isActive)}
            >
                {name}
            </label>
            <button
                className={styles.onlyButton}
                onClick={_onlyStationClick}
            >
                {t('only')}
            </button>
            <DirectionsMap
                buttonText={t('map')}
                className={styles.directionsLink}
                departStationId={id}
                labelClassName={styles.directionLabel}
                type="search"
            />
        </div>
    );
}

Station.propTypes = propTypes;

export { Station };
export default localize(Station, 'baseApp');
